import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@che-ins-ui/button';
import { Header } from '@/components/common/Header';
import { Footer } from '@/components/common/Footer';
import { ROUTES } from '@/components/routes';
import { scrollToTop } from '@/libs/helpers';
import { reachAnalyticsGoal, YANDEX_GOALS } from '@/libs/analytics';
import { FaqSection } from './Faq';
import { Hero } from './Hero';
import { Info } from './Info';
import { Steps } from './Steps';
import { useStyles } from './styles';
export const Homepage = () => {
    const classes = useStyles();
    useEffect(() => {
        reachAnalyticsGoal(YANDEX_GOALS.mainPage);
    }, []);
    return (_jsxs("div", { className: classes.root, children: [_jsx(Header, {}), _jsx(Hero, {}), _jsxs("main", { className: classes.main, children: [_jsx(Steps, {}), _jsx(ContinueButton, { text: "\u0420\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C" }), _jsx(Info, {}), _jsx(FaqSection, {}), _jsx(ContinueButton, { text: "\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u043F\u043E\u043B\u0438\u0441" })] }), _jsx(Footer, {})] }));
};
const ContinueButton = ({ text }) => {
    const classes = useStyles();
    const navigate = useNavigate();
    return (_jsx("div", { className: classes.scrollButtonContainer, children: _jsx(Button, { appearance: "continue", onClick: () => {
                navigate(ROUTES.order);
                requestAnimationFrame(() => scrollToTop({ behavior: 'auto' }));
            }, children: text }) }));
};
